import(/* webpackMode: "eager", webpackExports: ["ProtectedNavbar"] */ "/app/app/(protected)/_components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/components/navbar/navbar.tsx");
